/**
 * Presentation helpers shared by the contact table and the contact card list.
 * They live here rather than in `ContactsPage.tsx` so both views agree on what
 * "te lang stil" means and on how a last-contact moment reads.
 */
import { todayIso } from './dates'
import { addDays } from './query/dateRanges'

// `relatiefNl` moved to `lib/format` with the other date formatters; the pages that import it
// from here keep working.
export { relatiefNl } from '@/lib/format'

/** The three states of "Laatste contact" (addendum A.6): never, quiet for too long, recent. */
export type LastContactState = 'geen' | 'stil' | 'recent'

/** A relation is quiet when the last contact is not within the last 90 days. */
export const QUIET_DAYS = 90

/**
 * Same window as the filter "Geen contact sinds 90 dagen": the 90 calendar days up to and including
 * today. Contact on the 90th day back is outside it. "Never" is its own state (no chip).
 */
export function lastContactState(lastContactAt: string | null, today: string = todayIso()): LastContactState {
  if (!lastContactAt) return 'geen'
  return lastContactAt.slice(0, 10) < addDays(today, 1 - QUIET_DAYS) ? 'stil' : 'recent'
}

export const amberChipClass =
  'border-amber-400/70 bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-400'
